import React from "react";
import type { Season } from "../api/types";
import PointsTable from "../components/PointsTable";
import SpecialDays from "../components/SpecialDays";
import PrizeCard from "../components/PrizeCard";
import { fmtDayWithWeekday, seasonSpan } from "../utils/seasonText";

/** Step 1: what the game is. */
const StepRules: React.FC<{ season: Season; onNext: () => void }> = ({ season, onNext }) => (
  <div className="gm-step">
    <h2 className="gm-step-title">The game</h2>
    <p>
      {seasonSpan(season.totalDays, season.dayKeyFrom, season.dayKeyTo)} Every morning race earns
      points. On {fmtDayWithWeekday(season.dayKeyTo)} the best player who is not already in the top 3
      of the AOTD leaderboard takes the game's AOTD IRL.
    </p>
    <PointsTable points={season.points} />
    <SpecialDays days={season.specialDays} />
    <PrizeCard prizeText={season.prizeText} />
    {season.rulesText ? <p>{season.rulesText}</p> : null}
    <p>
      {season.countDaysBeforeJoin
        ? "Late joiners keep their earlier races."
        : "Your points start with the first race after you join."}
    </p>
    <div className="gm-nav">
      <button type="button" className="gm-button gm-button--block" onClick={onNext}>
        Next
      </button>
    </div>
  </div>
);

export default StepRules;
